var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "url(#paint0_linear_5980_4125)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.875V12.125C11.25 12.3239 11.171 12.5147 11.0303 12.6553C10.8897 12.796 10.6989 12.875 10.5 12.875H6.375C6.17609 12.875 5.98532 12.796 5.84467 12.6553C5.70402 12.5147 5.625 12.3239 5.625 12.125V8C5.625 7.80109 5.70402 7.61032 5.84467 7.46967C5.98532 7.32902 6.17609 7.25 6.375 7.25H8.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 6.125H12.375V8.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.25L12.375 6.125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5980_4125",
    x1: 2.5,
    y1: 0.5,
    x2: 18.25,
    y2: 20.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB09C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B75556"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.b35994ed1c5a7577a847f3a1416345dd.svg";
export { ForwardRef as ReactComponent };